"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.Consumer = exports.Provider = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _lodash = require("lodash");

/* eslint-disable */
var DEFAULT_CONTEXT = {
  addField: function addField(_ref) {
    var name = _ref.name,
        value = _ref.value;
  },
  removeField: function removeField(name) {},
  valueChanged: function valueChanged(name, value) {},
  isSubmitted: function isSubmitted() {
    return false;
  },
  submitForm: function submitForm() {},
  values: {},
  errors: {}
  /* eslint-enable */

};

var _createContext = (0, _react.createContext)(DEFAULT_CONTEXT),
    Provider = _createContext.Provider,
    Consumer = _createContext.Consumer;

exports.Consumer = Consumer;
exports.Provider = Provider;

var Form =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(Form, _Component);

  function Form() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      submitted: false,
      values: {},
      errors: {}
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "fields", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "errors", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "validators", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "addField", function (_ref2) {
      var name = _ref2.name,
          value = _ref2.value,
          validate = _ref2.validate;
      _this.fields[name] = value;
      _this.validators[name] = {
        validate: validate
      };

      _this.validate();

      _this.triggerOnChange(name);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "removeField", function (name) {
      var newFields = {};
      var newErrors = {};
      (0, _lodash.keys)(_this.fields).forEach(function (field) {
        if (name !== field) {
          newFields[field] = _this.fields[field];
          newErrors[field] = _this.errors[field];
        }
      });
      _this.fields = newFields;
      _this.errors = newErrors;
      _this.validators[name] = null;

      _this.validate();

      _this.triggerOnChange(name);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "checkSubmitted", function () {
      return _this.state.submitted;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "triggerOnChange", function (name) {
      var onChange = _this.props.onChange;

      _this.setState({
        values: _this.fields,
        errors: _this.errors
      });

      if (onChange) {
        onChange({
          fields: _this.fields,
          errors: _this.errors,
          lastChanged: name,
          valid: _this.isValid()
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "valueChanged", function (name, value) {
      if (name) {
        _this.fields[name] = value;

        _this.validate();

        _this.triggerOnChange(name);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "validate", function () {
      (0, _lodash.keys)(_this.fields).forEach(function (field) {
        _this.errors[field] = _this.validateField(field);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "validateField", function (field) {
      var validate = _this.validators[field].validate;

      if (!validate || typeof validate !== "function") {
        return '';
      }

      return validate(_this.fields[field]);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "isValid", function () {
      var errorKeys = (0, _lodash.keys)(_this.errors);
      var errors = (0, _lodash.findIndex)(errorKeys, function (field) {
        return _this.errors[field];
      });
      return errors < 0;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onSubmit", function () {
      var valid = _this.isValid();

      _this.setState({
        submitted: true
      });

      if (_this.props.onSubmit) {
        _this.props.onSubmit({
          valid: valid,
          fields: _this.fields,
          errors: _this.errors
        });
      }
    });
    return _this;
  }

  var _proto = Form.prototype;

  _proto.render = function render() {
    var _this$state = this.state,
        errors = _this$state.errors,
        values = _this$state.values;
    return _react.default.createElement(Provider, {
      value: {
        addField: this.addField,
        removeField: this.removeField,
        valueChanged: this.valueChanged,
        isSubmitted: this.checkSubmitted,
        submitForm: this.onSubmit,
        inForm: true,
        values: values,
        errors: errors,
        formValid: this.isValid()
      }
    }, this.props.children);
  };

  return Form;
}(_react.Component);

exports.default = Form;